module.exports = __webpack_public_path__ + "static/media/Meeting.f5b89220.JPG";